module.exports = __webpack_public_path__ + "img/user.228bcf56.jpg";